import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import {
  BaseballStatId,
  BaseballSubParticipantStatId,
} from '@collector/sportsapi-client-legacy'

export const teamStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: BaseballStatId.AB, name: 'AB' },
  { sportStatId: BaseballStatId.Runs },
  { sportStatId: BaseballStatId.Hits, name: 'Hit' },
  { sportStatId: BaseballStatId.RBI, name: 'RBI' },
  { sportStatId: BaseballStatId.BaseOnBalls },
  { sportStatId: BaseballStatId.Strikeouts },
  { sportStatId: BaseballStatId.Errors, name: 'Error' },
  { sportStatId: BaseballStatId.HomeRunHits, name: 'Home Run Hits' },
  { sportStatId: BaseballStatId.StolenBases, name: 'Stolen Bases' },
  { sportStatId: BaseballStatId.CaughtStealing, name: 'Caught Stealing' },
  {
    sportStatId: BaseballStatId.IP,
    name: 'IP',
    format: { decimal: true, decimalPlaces: 1 },
  },
  { sportStatId: BaseballStatId.HAllowed, name: 'H allowed' },
  { sportStatId: BaseballStatId.RAllowed, name: 'R allowed' },
  { sportStatId: BaseballStatId.ERAllowed, name: 'ER' },
  { sportStatId: BaseballStatId.BBAllowed, name: 'BB allowed' },
  { sportStatId: BaseballStatId.PitcherSO, name: 'Pitcher SO' },
  { sportStatId: BaseballStatId.HRAllowed, name: 'HR allowed' },
]

export const teamStatsAccordionIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: BaseballStatId.BackToBackHits },
  { sportStatId: BaseballStatId.HBP, name: 'HBP' },
  { sportStatId: BaseballStatId.WildPitch, name: 'Wild Pitch' },
  { sportStatId: BaseballStatId.SacrificeFly, name: 'Sacrifice fly' },
  { sportStatId: BaseballStatId.Single },
  { sportStatId: BaseballStatId.Double },
  { sportStatId: BaseballStatId.Triple },
  { sportStatId: BaseballStatId.Pitches },
  { sportStatId: BaseballStatId.Balls },
  { sportStatId: BaseballStatId.Strikes },
]

export const playerStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: BaseballStatId.AB, name: 'AB' },
  { sportStatId: BaseballStatId.Runs },
  { sportStatId: BaseballStatId.Hits },
  { sportStatId: BaseballStatId.RBI, name: 'RBI' },
  { sportStatId: BaseballStatId.BaseOnBalls, name: 'BB' },
  { sportStatId: BaseballStatId.Strikeouts },
  { sportStatId: BaseballStatId.Errors, name: 'Error' },
  { sportStatId: BaseballStatId.HomeRunHits, name: 'HR' },
  { sportStatId: BaseballStatId.StolenBases, name: 'SB' },
  { sportStatId: BaseballStatId.CaughtStealing, name: 'CS' },
  { sportStatId: BaseballStatId.Win, name: 'W' },
  { sportStatId: BaseballStatId.Loss, name: 'L' },
  { sportStatId: BaseballStatId.Saves, name: 'SV' },
  {
    sportStatId: BaseballStatId.IP,
    name: 'IP',
    format: { decimal: true, decimalPlaces: 1 },
  },
  { sportStatId: BaseballStatId.HAllowed, name: 'H allowed' },
  { sportStatId: BaseballStatId.RAllowed, name: 'R allowed' },
  { sportStatId: BaseballStatId.ERAllowed, name: 'ER' },
  { sportStatId: BaseballStatId.BBAllowed, name: 'BB allowed' },
  { sportStatId: BaseballStatId.PitcherSO, name: 'Pitcher SO' },
  { sportStatId: BaseballStatId.HRAllowed, name: 'HR allowed' },
  { sportStatId: BaseballSubParticipantStatId.GameStarted },
  { sportStatId: BaseballSubParticipantStatId.Appearance },
  { sportStatId: BaseballStatId.Single },
  { sportStatId: BaseballStatId.Double },
  { sportStatId: BaseballStatId.Triple },
  { sportStatId: BaseballStatId.WildPitch },
  { sportStatId: BaseballStatId.SacrificeFly, name: 'SF' },
  { sportStatId: BaseballStatId.Pitches },
  { sportStatId: BaseballStatId.Balls },
  { sportStatId: BaseballStatId.Strikes },
  { sportStatId: BaseballStatId.HBP, name: 'HBP' },
]
